import React, { Fragment } from 'react';

const CampaignDetail = ({ id, translations }) => {
  return (
    <Fragment>
      <div className='MainHeader'>
        <div className='MainHeader__left'>
          <h2 className='MainHeader__h2'>Campaign #{id}</h2>
        </div>
      </div>

      <div className='Table Table--user-1'>
        <div className='Table__row'>
          <div className='Table__col Table__col--th'>Language</div>
          <div className='Table__col Table__col--th'>Description</div>
        </div>

        {translations.map((translation) => (
          <div className={'Table__row'} key={`translation_${translation.locale}`}>
            <div className='Table__col'>{translation.locale}</div>

            <div className='Table__col'>
              {translation.description}<br/>
              {translation.descriptionUrl}
            </div>

          </div>
        ))}
      </div>
    </Fragment>
  );
}

export default CampaignDetail
